import { NeutralColors } from 'portfolio3/styles';
import { SxStyles } from 'types';

export const root: SxStyles = {
  border: '1px solid',
  borderColor: NeutralColors.light_neutrals_300,
  borderRadius: '12px',

  boxShadow: '0px 1px 2px 0px #29294012',
};

export const mainContainer: SxStyles = (theme) => ({
  display: 'flex',
  gap: '20px',
  justifyContent: 'space-between',

  paddingBlock: '16px 12px',
  paddingInline: '20px',

  [theme.breakpoints.down('commonSm')]: {
    flexDirection: 'column',
    gap: '12px',

    padding: '12px',
  },
});
